import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "token",
  initialState: "",
  reducers: {},
});

export default authSlice.reducer;
